import axios from 'axios';

export const clientAddressApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-address`,
    headers: {
        'Content-Type': 'application/json'
    }
})